import type { TFunction } from 'i18next';

export enum AssociationAccountTypeEnum {
  Unknown = -1, // okänd typ
  Bankgiro = 1,
  Plusgiro = 2,
  IBAN = 3,
}

export function getAssociationAccountTypeDescription(type: AssociationAccountTypeEnum, t: TFunction): string {
  const translationKeys: Record<AssociationAccountTypeEnum, string> = {
    [AssociationAccountTypeEnum.Unknown]: t('invoice:adminInvoiceGroupDetailPage.unknown'),
    [AssociationAccountTypeEnum.Bankgiro]: t('invoice:adminInvoiceGroupDetailPage.bankgiro'),
    [AssociationAccountTypeEnum.Plusgiro]: t('invoice:adminInvoiceGroupDetailPage.plusgiro'),
    [AssociationAccountTypeEnum.IBAN]: t('invoice:adminInvoiceGroupDetailPage.iban'),
  };

  const key = translationKeys[type] || 'invoice:adminInvoiceGroupDetailPage.unknown';
  return t(key);
}
